module.exports = __webpack_public_path__ + "static/media/IMG-20250523-WA0005[1].14df3cf4.jpg";